export default __webpack_public_path__ + "static/production2r-62c1a71376c0f01899778b1f974b8277.jpg";